import React, { lazy, Suspense, useEffect, useState } from "react";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import WebRoutes from "./web/WebRoutes";
import MobileSeoServiceSection from "./app/mobile/seo/MobileSeoServiceSection";
import SplashScreen from "./app/mobile/screens/SplashScreen";
import WelcomeScreen from "./app/mobile/screens/WelcomeScreen";

const AppRoutes = lazy(() => import("./app/AppRoutes"));

const seoMobilePaths = new Set([
  "/",
  "/hpn-airport-car-service",
  "/hpn-airport-car-service/",
  "/westchester-airport-car-service",
  "/westchester-airport-car-service/",
  "/yorktown-heights-black-car-service",
  "/yorktown-heights-black-car-service/",
  "/manhattan-private-car-service",
  "/manhattan-private-car-service/",
  "/jet-black-transportation",
  "/jet-black-transportation/",
  "/online-booking",
  "/online-booking/",
]);

const mobileLandingHeadings = {
  "/hpn-airport-car-service": "HPN AIRPORT CAR SERVICE",
  "/westchester-airport-car-service": "Westchester Airport Car Service",
  "/yorktown-heights-black-car-service": "Yorktown Heights Black Car Service",
  "/manhattan-private-car-service": "Private Car Service in Manhattan",
  "/jet-black-transportation": "Jet Black Transportation in New York",
  "/online-booking": "Online Booking for Jet Black Limousine",
};

function DeferredAnalytics() {
  const [AnalyticsComponent, setAnalyticsComponent] = useState(null);

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") {
      return undefined;
    }

    let cancelled = false;
    const loadAnalytics = () => {
      import("@vercel/analytics/react")
        .then(({ Analytics }) => {
          if (!cancelled) {
            setAnalyticsComponent(() => Analytics);
          }
        })
        .catch(() => {});
    };
    const requestIdle = window.requestIdleCallback || ((callback) => window.setTimeout(callback, 1500));
    const cancelIdle = window.cancelIdleCallback || window.clearTimeout;
    const handle = requestIdle(loadAnalytics);

    return () => {
      cancelled = true;
      cancelIdle(handle);
    };
  }, []);

  return AnalyticsComponent ? <AnalyticsComponent /> : null;
}

function InterfaceRoutes() {
  const location = useLocation();
  const [isAppViewport, setIsAppViewport] = useState(
    () => window.innerWidth <= 768
  );

  useEffect(() => {
    const updateInterface = () => {
      setIsAppViewport(window.innerWidth <= 768);
    };

    window.addEventListener("resize", updateInterface);
    return () => window.removeEventListener("resize", updateInterface);
  }, []);

  const isMobileHome = location.pathname === "/";
  const isSeoMobilePath = seoMobilePaths.has(location.pathname);
  const normalizedPath = location.pathname.replace(/\/+$/, "") || "/";
  const mobileLandingHeading = mobileLandingHeadings[normalizedPath];

  if (isAppViewport && isSeoMobilePath) {
    return (
      <>
        {mobileLandingHeading && (
          <h1 style={{
            position: "absolute",
            width: "1px",
            height: "1px",
            padding: 0,
            margin: "-1px",
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            border: 0,
          }}>
            {mobileLandingHeading}
          </h1>
        )}
        <SplashScreen headingTag={isMobileHome ? "h1" : "div"}>
          <WelcomeScreen disableSeo headingTag={isMobileHome ? "h1" : "div"} />
        </SplashScreen>
        <MobileSeoServiceSection pathname={location.pathname} />
      </>
    );
  }

  return isAppViewport ? (
    <Suspense fallback={null}>
      <AppRoutes />
    </Suspense>
  ) : (
    <WebRoutes />
  );
}

function App() {
  return <Router>
    <div className="container">
      <InterfaceRoutes />
      <DeferredAnalytics />
    </div>
  </Router>;
}

export default App;
